module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "number1"
  }, [_vm._v("49. "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Think through what you want to say in emails before you type them out.")]), _vm._v(" Far too often we quickly respond to messages thinking we’re being more efficient, but the speed of our response means that we forget things in the note or aren’t as clear as we can be. When you think through that message before sending it, you’re making sure that your point gets across in email number one and you don’t get sucked into a longer email chain where you have to clarify your original point.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("50. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Make key people like your spouse, parent, or child “favorites” in your phone.")]), _vm._v(" When you do, you can put your phone in Do Not Disturb mode whenever you need to without the fear that you’ll accidentally miss an urgent call or text from that person. Do Not Disturb mode can be an exceptionally useful feature in ensuring that your phone doesn’t constantly grab your attention during the day and disrupt what you’re working on. Those important calls and texts from favorites will still get through, but all the unimportant noise will be filtered out.")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("51. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Create an evening routine for what you do right before bed.")]), _vm._v(" Routines aren’t just for your workday. An evening routine can help put your body in the mindset for bed so you fall asleep much faster. For instance, you might take the dog out for a quick stroll at eight thirty p.m., then have a cup of tea at nine p.m. and read a chapter of a book to wind down. The more you stick to your routine, the more you’ll get used to it and the easier it will become.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("52. ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Give yourself plenty of access to natural light during the day.")]), _vm._v(" Humans aren’t built to spend the day closed up in dark, windowless offices. Make it a point to get outside during the day to take in some sunlight. While you might not have that corner office, try to sit near windows whenever possible to experience sunlight during the workday. Exposure to the sun regulates your vitamin D levels, improving your mood, reducing stress, and helping you focus more. It is also essential to maintaining healthy bones.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("53. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Carry a small pad of paper and a pen with you at all times.")]), _vm._v(" This way you can jot down notes and to-dos while you’re out and about so they’re not forgotten. You can also create a digital version on your phone using your phone’s Notes app or another note-taking app such as Google Keep.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("54. ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Don’t be a multitasker.")]), _vm._v(" A study by Stanford researchers found that people who multitasked were more distracted and had a harder time remembering what they were doing than those who didn’t multitask. Instead of doing two or more things simultaneously, do one task and then move on to the next. By giving each task your complete focus, you’ll do a better job "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" get everything done faster.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("55. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Learn your grocery store.")]), _vm._v(" If you always shop at the same place, learn where things are located in the store and then create your shopping list based on those locations. So, if your grocery has eight aisles, then your grocery list will have eight sections. By organizing your list based on where an item is in the store, you can make one quick and efficient trip rather than constantly running back to get that “one thing” on your list you overlooked a few aisles back.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("56. ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Take a cold shower.")]), _vm._v(" Yes, hot showers are far more enjoyable; however, cold showers are known to increase your alertness and improve your immune system and circulation while also easing stress. If you find yourself in need of a focus or energy boost, try taking a five- to ten-minute cold shower to get your blood flowing. When you’re done, you’ll feel refreshed and ready to tackle the rest of your day.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("57. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Follow the two-minute rule.")]), _vm._v(" In general, if tasks come along that can be done in two minutes or less, you should do them immediately. The act of adding an item to your to-do list and coming back to it later will take up the better part of two minutes anyway. Completing tasks immediately will keep your to-do list short and your day moving along.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("58. ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Learn how to speed-read.")]), _vm._v(" Being able to process large amounts of text in short periods of time can dramatically increase your productivity and give you more time to focus on other tasks. There are tons of books and tools out there to help you learn the skill. One easy way to get started is to put a white index card above the line you’re currently reading. The card will block out what you’ve already read and keep your eyes moving down the page.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("59. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Chew gum.")]), _vm._v(" Gum can increase the amount of oxygen that is sent to your brain, giving you an extra boost of energy so you can better focus on the task at hand.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("60. ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Sit next to someone who is being productive.")]), _vm._v(" That person’s productivity isn’t going to physically rub off on you, but sitting next to someone who is head-down on a project and working hard will inspire you to do the same. No one wants to be the guy browsing "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Facebook")]), _vm._v(" next to someone who is pumping out a hundred-page report. Productivity is contagious—just find somewhere to sit where you can catch it!")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("61. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Enlist a money manager.")]), _vm._v(" Money is one of the biggest points of stress in life. Hiring a money manager to help you handle your finances can be a great way to set yourself up for success down the line. She can help you reach your savings and investment goals and make smart decisions about your future.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("62. ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Get up to (typing) speed.")]), _vm._v(" Being a slow typer will impede almost everything you do in a work setting as well as sometimes in your personal life. You’ll be slower at responding to chat messages, slower at responding to emails, and slower at writing reports. Learning how to type faster is just a matter of teaching your hands where the different letters are on the keyboard. If you know you’re slow, try to spend a few minutes each day practicing. There are a number of different online tools out there that can help you learn and sharpen your skills.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("63. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Make a timed playlist to use when completing certain tasks.")]), _vm._v(" Instead of using a timer or clock to keep track of the time, use music to make things more enjoyable and to avoid continually looking at the clock while you work. For instance, you might have a ten-minute playlist for taking a shower in the morning or a thirty-minute playlist you listen to while you’re preparing dinner. Over time your mind and body will learn that a certain song means that you need to get up and get dressed or that it’s almost time to go to work.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("64. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Practice a self-affirming exercise.")]), _vm._v(" At the end of each day, ask yourself if you think you gave that day your best effort. If you did, then this is a great way to motivate yourself to be even more productive tomorrow. If you didn’t, then you can pinpoint places where you had trouble during the day and focus on overcoming those obstacles tomorrow. When you constantly strive to do your best, it shows. Strive to have more and more days where you can say you did the best you could!")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("65. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Get feedback from others.")]), _vm._v(" The only way to get better at something is to know where you need to improve, and it’s often hard to highlight your own shortcomings. Instead, always seek out feedback from others, be they coworkers, family members, or people you’re just serving on a committee with. Just asking the simple question “How could I be doing better here?” can give you insight into not only what you’re excelling at but also what you can work on going forward.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "number1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("66. "), _c('span', {
    staticClass: "txbf"
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Take a personal day.")]), _vm._v(" If your personal to-do list starts to get out of hand, consider taking a day off from work to tackle it. The whole point of taking a vacation is to cut down on stress. If your personal stress is starting to become too much to handle, then taking a vacation day to knock things off your to-do list can actually help you de-stress better than taking a day off to relax on the beach.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "number1"
  }, [_vm._v("67. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Take your time.")]), _vm._v(" Working quickly doesn’t always mean you’re being your most productive. When you move too fast, you often miss things in the process and make mistakes. Slow down on important tasks so that you can really give them the attention they deserve. This way you ensure the job is done right (and well) the first time!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478fbb91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01e.vue
// module id = 87
// module chunks = 0